import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { AiOutlineFileAdd } from 'react-icons/ai'
import { FiDownload } from 'react-icons/fi'

import { employeeAction } from '../../actions'
import { employeeSelector } from '../../selectors'

import { Button } from '../../components/buttons'
import { SearchBar } from '../../components/search-bar'

export const ActionBar = React.memo(({ handleClickCreate }) => {
  const access_token = localStorage.getItem('access_token')
  const dispatch = useDispatch()
  const exportUrl = useSelector(employeeSelector.getExportURL)

  useEffect(() => {
    if (exportUrl) {
      window.open(exportUrl, '_blank')
      dispatch(employeeAction.resetExportUser())
    }
  }, [exportUrl])


  const handleSearch = () => {
    const keywordSearch = document.getElementById('keywordSearch')
    dispatch(employeeAction.setKeywordSearch({ keywordSearch: keywordSearch.value }))
  }

  const handleClickExport = () => {
    dispatch(employeeAction.exportUser(access_token))
  }

  // const handleClickImport = async payload => {
  //   await dispatch(employeeAction.importUser(payload, access_token))
  // }

  // const uploadFile = e => {
  //   const file = e.target.files[0]
  //   const data = new FormData()
  //   data.set('csv', file)
  //   handleClickImport(data)
  //   document.getElementById('fileUpload').value = null
  // }

  return (
    <Root>
      <SearchBar handleSearch={ handleSearch } />
      <Wrapper>
        <ButtonGroup>
          {/* <Button
            bold
            theme='#428BCA'
            icon={ <FiUpload style={ { fontSize: 16 } } /> }
            width='82px'
            height='26px'
            style={ { position: 'relative' } }
          >
            <InputFile
              type='file'
              id='fileUpload'
              name='file'
              onChange={ uploadFile }
            />
              Import
          </Button> */}
          <Button
            theme='#428BCA'
            icon={ <FiDownload style={ { fontSize: 16 } } /> }
            width='82px'
            height='26px'
            onClick={ handleClickExport }
          >
            Export
          </Button>
        </ButtonGroup>
        <Button
          theme='#D44B49'
          icon={ <AiOutlineFileAdd style={ { fontSize: 16 } } /> }
          width='82px'
          height='26px'
          onClick={ handleClickCreate }
        >
          Create
        </Button>
      </Wrapper>
    </Root>
  )
})

const Root = styled.div`
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    padding: 0 24px;
    margin-bottom: 12px;
`

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
`

const ButtonGroup = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    div:nth-child(1) {
      margin-left: 18px;
      margin-right: 12px;
    }

    input[type=file],
    input[type=file]::-webkit-file-upload-button {
      cursor: pointer; 
    }
`

// const InputFile = styled.input`
//     width: 100%;
//     height: 100%;
//     opacity: 0;
//     position: absolute;
//     z-index: 1;
// `



// WEBPACK FOOTER //
// ./src/components/new-employee/action-bar.js